import React, { useState } from 'react';
import './ContactPage.css';

export default function ContactPage() {
  const [status, setStatus] = useState(null); // 'submitting', 'success', 'error'

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('submitting');
    
    const form = e.target;
    const formData = new FormData(form);

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: formData
      });

      const data = await response.json();

      if (data.success) {
        setStatus('success');
        form.reset();
      } else {
        setStatus('error');
        console.error("Error submitting form:", data);
      }
    } catch (error) {
      setStatus('error');
      console.error("Network error submitting form:", error);
    }
  };

  return (
    <div className="contact-page container">
      <div className="contact-header">
        <h1>Get in <span className="text-neon">Touch</span></h1>
        <p>Have questions about PlayerMaker 2.0? We're here to help.</p>
      </div>

      <div className="contact-grid">
        <div className="contact-info">
          <h3>Contact Information</h3>
          <p>Reach out to us directly or fill out the form, and we'll get back to you as soon as possible.</p>

          
          <div className="info-item">
            <span className="icon">💬</span>
            <div>
              <strong>WhatsApp</strong>
              <p>Use the chat button in the bottom right corner.</p>
            </div>
          </div>
        </div>

        <div className="contact-form-container">
          <form className="contact-form" onSubmit={handleSubmit}>
            <input type="hidden" name="access_key" value="a22ada06-187c-4fe7-b5d0-8fe25128193c" />
            <input type="hidden" name="from_name" value="iLOVEthisgame Contact Form" />
            
            <div className="form-group">
              <label htmlFor="name">Full Name</label>
              <input type="text" id="name" name="name" required placeholder="John Doe" />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <input type="email" id="email" name="email" required placeholder="john@example.com" />
            </div>

            <div className="form-group">
              <label htmlFor="subject">Subject</label>
              <input type="text" id="subject" name="subject" required placeholder="How can we help?" />
            </div>

            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea id="message" name="message" rows="5" required placeholder="Your message here..."></textarea>
            </div>

            {/* Honeypot Spam Protection */}
            <input type="checkbox" name="botcheck" className="hidden" style={{ display: 'none' }} />

            <button 
              type="submit" 
              className="btn btn-primary"
              disabled={status === 'submitting'}
            >
              {status === 'submitting' ? 'Sending...' : 'Send Message'}
            </button>

            {status === 'success' && (
              <div className="form-message success">
                Thanks! Your message has been sent successfully. We will be in touch soon.
              </div>
            )}
            
            {status === 'error' && (
              <div className="form-message error">
                Oops! Something went wrong. Please try again or email us directly.
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
}
